import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { MessageThread } from '../api';

interface MessageDetailProps {
  thread: MessageThread | null;
}

export const MessageDetail = ({ thread }: MessageDetailProps) => {
  // const [execQuery, result] = useOrganizationAddressInfoLazyQuery();

  // useEffect(() => {
  //   if (!thread) return;

  //   execQuery({ variables: { organizationId: String(thread.organizationId) } });
  // }, [thread, execQuery]);

  if (!thread) return null;

  // result?.data?.result?.find((l) => location with type main)
  const siteLocation = thread?.organizationName;

  return (
    <div className='my-4 mx-5'>
      <Row className='mb-3'>
        <Col xs={12} sm={4}>
          <span className='fs-3'>
            <span>Subject</span>: <strong>{thread.subject}</strong>
          </span>
        </Col>
        <Col xs={12} sm={4}>
          <span className='fs-3'>
            {/* <span>Prescriber Name</span>: <strong>{thread.providerName}</strong> */}
            <span>Prescriber Name</span>: <strong>{thread.providerName}</strong>
          </span>
        </Col>
        <Col xs={12} sm={4} className='d-flex justify-content-end'>
          <span className='fs-3'>
            <span>Drug / Product</span>: <strong>{thread.therapy}</strong>
          </span>
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col xs={12} sm={6}>
          <span className='fs-3'>
            <span>Patient ID</span>: <strong>{thread.patientId}</strong>
          </span>
        </Col>
        <Col xs={12} sm={6} className='d-flex justify-content-end'>
          <span className='fs-3'>
            <span>Site/Location</span>: <strong>{siteLocation}</strong>
          </span>
        </Col>
      </Row>
    </div>
  );
};
